import axios from 'axios';
import { v4 as uuid } from 'uuid';
import { FetchLocationParams, Location } from 'common/types/mapBox';

/**
 * Generates a unique session token using UUID.
 */
const sessionToken = uuid();

/**
 * Retrieves the Mapbox access token from environment variables.
 */
const accessToken = process.env.REACT_APP_MAP_BOX_TOKEN;

/**
 * Creates an Axios instance with the base URL for the Mapbox Search API.
 */
const axiosInstance = axios.create({
  baseURL: 'https://api.mapbox.com/search/searchbox/v1',
});

/**
 * Fetches all locations based on search parameters.
 *
 * @param {FetchLocationParams} params - The search parameters object containing the search item and country (optional).
 * @returns {Promise<Location[]>} A Promise that resolves to an array of Location objects.
 */
export const fetchAllLocations = ({
  searchItem,
  country,
}: FetchLocationParams) =>
  axiosInstance.get<Location[]>(
    `suggest?q=${searchItem}&country=${
      country || 'pt'
    }&types=street,address&access_token=${accessToken}&session_token=${sessionToken}`,
  );
